import React from 'react';
import { useTranslation } from 'react-i18next';

import CardEditForm from '../CardEditForm';
import { CategoryField } from './CategoryField';

export default function CategoryEdit() {
    const { t } = useTranslation('cards');

    return (
        <CardEditForm title={t('profileEdit.label.category')}>
            {() => (
                <CategoryField
                    id="profile_category"
                    label={t('profileEdit.label.category')}
                    name="profile.category"
                    extra={{
                        label: t('profileEdit.label.categoryCustom'),
                        placeholder: t('profileEdit.placeholder.categoryCustom'),
                        maxLength: 30,
                    }}
                />
            )}
        </CardEditForm>
    );
}
